import React from "react";
import MiniCard from "./Mini-Card";
import "./First-Card-Section.scss";

//icons
import { MdCreditScore } from "react-icons/md";

import { MdWaterDrop } from "react-icons/md";
import { FaClock } from "react-icons/fa";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { FaTrash } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa";
const FirstCardSection = ({
  paymentProgressInvoices,
  paymentProgressPayments,
  propertyDetails,
  dataInCards
}) => {
  const rent = paymentProgressInvoices?.rent || Number.MAX_SAFE_INTEGER;
  const garbage = paymentProgressInvoices?.garbage || Number.MAX_SAFE_INTEGER;
  const water = paymentProgressInvoices?.water || Number.MAX_SAFE_INTEGER;
  const arrears = paymentProgressInvoices?.unpaidDeposit || Number.MAX_SAFE_INTEGER;
  
  const rentPaid = paymentProgressPayments?.rent_amount || 0;
  const garbagePaid = paymentProgressPayments?.garbage_charge_amount || 0;
  const waterPaid = paymentProgressPayments?.water_bill_amount || 0;
  const arrearsPaid = paymentProgressPayments?.arrears_amount || 0;

  return (
    <div className="mini-card-container">
      <MiniCard
        title="Houses Occupied"
        amount={`${dataInCards?.housesOccupied || 0}`}
        percentage={`${((dataInCards?.housesOccupied / dataInCards?.totalHouses) * 100)}`}
        IconType={FaUsers}
      />
      <MiniCard
        title="Payments Made"
        amount={`ksh ${dataInCards?.paymentsMade || 0}`}
        percentage={`${((dataInCards?.paymentsMade / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100) || 0}`}
        setColorAlternate={true}
        IconType={MdCreditScore}
      />
      <MiniCard
        title="Pending Invoices"
        amount={`ksh ${dataInCards?.pendingInvoices || 0}`}
        percentage={`${((dataInCards?.pendingInvoices / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100) || 0}`}
        setMarginTop={true}
        setColorAlternate={true}
        IconType={LiaFileInvoiceSolid}
      />
      <MiniCard
        title="Arrears Paid"
        amount={`ksh ${dataInCards?.arrearsReconciled || 0}`}
        percentage={ ((dataInCards?.arrearsReconciled / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100) || 0}
        setMarginTop={true}
        IconType={FaClock}
      />
    </div>
  );
};

export default FirstCardSection;
